import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/atoms/Spinner';
import SomethingHappened from '@/components/SomethingHappened';
import { withSentry } from '@/utils/withSentry';

import { useAuth } from '../contexts/auth';

import LoggedInRoutes from './LoggedInRoutes';
import Public from './Public';

export default function Routes() {
    const {
        isAuthenticating,
        isAuthenticated,
        user,
        sessionUnavailable,
        retrySession,
        isRetryingSession,
    } = useAuth();
    const { t } = useTranslation();

    if (isAuthenticating) {
        return <Spinner size="lg" fullScreen />;
    }

    if (isAuthenticated && user) {
        withSentry((s) =>
            s.setUser({
                id: String(user.id),
                email: user.email,
            })
        );

        return <LoggedInRoutes />;
    }

    if (sessionUnavailable) {
        return (
            <SomethingHappened
                headingLevel="h1"
                title={t('common.errors.sessionUnavailable')}
                onRetry={retrySession}
                isRetrying={isRetryingSession}
            />
        );
    }

    return <Public />;
}
